import React from "react";
import { Navigate } from "react-router-dom";
import { getSession } from "./utils/session";

const ProtectedRoute = ({ children }) => {
  const session = getSession();

  if (!session || !session.email) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;